import React from 'react'
import './UserRegistrationForm.css'
// import { CountrySelect } from '../../../../../common/CountrySelect/CountrySelect'
import { GenericSelect } from '../../../../../common/GenericSelect/GenericSelect'
import { useGetData } from '../../../../../../hooks/useGetData'
import { FetchData, useSubmitData } from '../../registerControler'
import logoSB from '../../../../../../assets/img/logo-colores-originales-sin-bajada.png'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { useToast } from '../../../../../../hooks/useToast'
import { useRedirect } from '../../../../../../hooks/useRedirect'
import { MySelect } from '../../../../../common/testGenericSelect/flagsSelect'


// import { GenericComponent } from '../../../../../common/GenericComponent/GenericComponent'

export const UserRegistrationForm = () => {





    useEffect(() => {
        document.title = "TPA® Oficial - Formulario de interés"
    }, [])

    const { data } = useGetData(FetchData)



    const yesOrNot = [
        { name: 'Si', description: '', id: 'si' },
        { name: 'No', description: '', id: 'no' }

    ]


    function generateYearsArray() {
        const currentYear = new Date().getFullYear()
        const startYear = 2017
        const yearsArray = []

        for (let year = currentYear; year >= startYear; year--) {
            yearsArray.push({ name: year, description: '', id: year })
        }
        //console.log('years are: ',yearsArray)
        return yearsArray;

    }


    const years = generateYearsArray();


    const { register, handleSubmit, onSubmit, setValue, message, errors, response, setMessage, setResponse } = useSubmitData()
    const [selectedValue, setSelectedValue] = useState(null);



    //console.log('errors es: ', errors)

    const handleSelectChange = (selectedOption) => {
        setSelectedValue(selectedOption)

    }

    //console.log('data from useGetData: ',data)



    // const fasePresencialRef = useRef() // Referencia para el campo "year"
    // const prefixRef = useRef()

    // useEffect(() => {
    //     if (errors.fasePresencial && fasePresencialRef.current) {
    //       fasePresencialRef.current.focus() // Enfocar el select de "year" si este campo tiene error
    //     }else if (errors.prefix1 && prefixRef.current){
    //         prefixRef.current.focus()
    //     }
    //   }, [errors])

    const formatDataforGenericSelect = (data) => {

        //console.log('data es: ', data)
        let options;
        if (data) {
            options = data.map((i) => {

                let description = i.name ?? i.description ?? i.prefix
                if (i.name && i.description.length > 0) {
                    //console.log('description: ', description)
                    //👉 si existe name pero con prop .length > 0
                    return {
                        value: `${i.id}`,
                        label: `${i.name} (${i.description})`,
                    }
                }

                else {
                    return {
                        value: i.id,
                        label: description
                    }
                }
            })
        }

        return options
    }

    const { showToast } = useToast();

    useEffect(() => {
        if (message && response) {
            //console.log('RESULT ES: ', response, message)
            showToast(response, message)
            setMessage('')
            setResponse(null)
        }
    }, [message, showToast, response])



    const { redirectTo } = useRedirect()

    useEffect(() => {
        if (response) {



            redirectTo('/completed-form', response, {

                message: `${message}`,
                title: "Registro Exitoso"

            })
        }
    }, [response, redirectTo, message])



    return (

        <div className="form-container-interest">

            <ToastContainer
            />

            <form id="miFormulario" className="form-interest" onSubmit={handleSubmit(onSubmit)}>

                <Link className="back" to="/login"><i className="bi bi-arrow-left bi-class-back
                "></i>Volver</Link>


                <div className="logo-interest">
                    <img src={logoSB} alt="logo" />
                </div>


                <h1 className="title-interest">Formulario de interés</h1>

                <p className="intro">Para que podamos contactarte a la brevedad y enviarte la información sobre la Formación
                    Profesional TPA® o cómo adquirir la Membresía Profesional TPA®, por favor completa el formulario con
                    tus datos personales.</p>

                <div className="first-question">
                    <div className=" mt-5 container-mt-5 mt-5-height container-mw">
                        <div className="mb-3 mb3-class form-floating select-container ">

                            <div className="div-fq">¿Realizó anteriormente La Formación
                                TPA®?</div>


                            <GenericSelect
                                values={formatDataforGenericSelect(yesOrNot)}
                                name={'HasProfession'}
                                onSelectChange={handleSelectChange}
                                placeholder={'Seleccionar'}
                                {...register('HasProfession', { required: true })}
                                setValue={setValue} />



                        </div>
                    </div>



                    {selectedValue && selectedValue.value === "si" ?
                        <div className="mt-5 container-mt-5 cont-year mt-5-height">
                            <div className=" mb3-class-year select-container">

                                <div className="div-year">Año en que realizaste la Formación TPA®</div>

                                <GenericSelect
                                    name="yearOfEnrollment"
                                    values={formatDataforGenericSelect(years)}
                                    prop={'year'}
                                    // onSelectChange={(selectedOption) => setValue('year', selectedOption.year)}
                                    {...register('yearOfEnrollment', { required: true })}
                                    setValue={setValue}

                                />



                            </div>
                        </div>
                        :
                        null
                    }

                </div>





                {/* <!-- "className="form-control is-invalid"" establece error de input --> */}


                <div className="datos-container">

                    <span className="address-title-datos">Datos Personales</span>

                    <div className="form-floating">

                        <input
                            type="text"
                            id="floatingInputName"
                            placeholder="Nombre"
                            name={'name'}
                            // onBlur={onBlur}
                            className={`form-control form-control-height ${errors.name ? 'inError' : ''}`}
                            {...register('name', {
                                required: 'Campo requerido', pattern: {
                                    // Permite letras (A-Z), espacios (\s) y caracteres acentuados (À-ÿ)
                                    value: /^[A-Za-zÀ-ÿ\s]*$/,
                                    message: "Solo se permiten letras y espacios"
                                }
                            })}
                        />
                        <label htmlFor="floatingInputName">Nombres * </label>
                        {errors.name &&

                            <span className='invalid-feedback d-flex field-validation-error'>
                                <span className="error-message">{errors.name.message}</span>
                            </span>
                        }

                    </div>

                    <div className="form-floating">
                        <input
                            type="text"
                            id="floatingLast"
                            placeholder="Apellido"
                            className={`form-control form-control-height ${errors.lastName ? 'inError' : ''}`}
                            name={'lastName'}
                            {...register('lastName', {
                                required: 'Campo requerido',
                                pattern: {
                                    // Permite letras (A-Z), espacios (\s) y caracteres acentuados (À-ÿ)
                                    value: /^[A-Za-zÀ-ÿ\s]*$/,
                                    message: "Solo se permiten letras y espacios"
                                }
                            })} />

                        <label htmlFor="floatingLast">Apellidos *</label>

                        {errors.lastName &&

                            <span className='invalid-feedback d-flex field-validation-error'>
                                <span className="error-message">{errors.lastName.message}</span>
                            </span>
                        }
                    </div>

                    <div className="dni">
                        <div className="form-floating selected1 select-container">

                            <GenericSelect
                                name={'documentTypeId'}
                                placeholder={'Tipo de Documento'}
                                placeholderAsOption={true}
                                values={formatDataforGenericSelect(data?.[1]?.data || [])}
                                prop={'description'}
                                setValue={setValue}
                                {...register('documentTypeId', { required: true })}
                            />


                        </div>
                        <div
                            className="form-floating nro">
                            <input type="text"
                                className={`form-control form-control-height ${errors.dni ? 'inError' : ''}`}
                                id="floatingNro"
                                placeholder="Nro"
                                name={'dni'}
                                {...register('dni', { required: 'Campo requerido' })} />
                            <label htmlFor="floatingNro">Nro de Documento *</label>

                            {errors.dni &&

                                <span className='invalid-feedback d-flex field-validation-error'>
                                    <span className="error-message">{errors.dni.message}</span>
                                </span>
                            }
                        </div>
                    </div>


                </div>



                <div className="address-1">
                    <span className="address-title">Contacto</span>



                    <div className="input-group mb-3">
                        <span className="input-group-text height-58"><i className="bi bi-envelope bi-class-Envelope"></i></span>

                        <div className="form-floating flex-grow-1">
                            <input type="text"
                                id='code1'
                                className={`form-control form-control-height ${errors.email ? 'inError' : ''}`}
                                name="email"
                                placeholder="Code 1"
                                {...register('email', {

                                    // 👉 Mensaje por campo vacio
                                    required: "Campo requerido",

                                    pattern: {
                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,

                                        // 👉 Mensaje por formato invalido
                                        message: "Formato de correo inválido",
                                    },
                                })} />

                            <label htmlFor="code1">Email *</label>

                            {errors.email &&

                                <span className='invalid-feedback d-flex field-validation-error'>
                                    <span className="error-message">{errors.email.message}</span>
                                </span>
                            }
                        </div>

                    </div>



                    <div className="address-1-container">
                        <div className=" mt-5-country mt-5">

                            <div className="mb-3 mb3-class-country select-container ">

                                {/* <CountrySelect placeholder={'País'}
                                    values={data?.[0]?.data}
                                    setValue={setValue}
                                    name={'phonePrefixId'}
                                    {...register('phonePrefixId', { required: true })}
                                    countryClass={errors.PhonePrefixId ? 'inErrorCountry' : ''}


                                /> */}


                                <MySelect

                                    placeholder={'País'}
                                    values={data?.[0]?.data}
                                    setValue={setValue}
                                    name={'phonePrefixId'}
                                    {...register('phonePrefixId', { required: true })}
                                    countryClass={errors.PhonePrefixId ? 'inErrorCountry' : ''}
                                    isRequired={true} //👉 prop para activar el efecto inErrorSelect
                                />

                            </div>

                        </div>




                        <div className="form-floating input-group-phone ">


                            <input type="text"
                                inputMode='tel'
                                className={`form-control form-control-height ${errors.phoneNumber ? 'inError' : ''}`}
                                id="autoSizingInputGroup1"
                                placeholder="Celular"
                                name={'phoneNumber'}
                                {...register('phoneNumber', { required: 'Campo requerido' })}
                                onChange={(e) => {
                                    // Limpia cualquier símbolo no numérico, como guiones o puntos
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '')
                                }}
                            />
                            <label htmlFor="autoSizingInputGroup1">Celular *</label>


                            {errors.phoneNumber &&

                                <span className='invalid-feedback d-flex field-validation-error'>
                                    <span className="error-message">{errors.phoneNumber.message}</span>
                                </span>
                            }
                        </div>

                    </div>


                    <div className="address-2-container">

                        <div className="container mt-5-country mt-5">

                            <div className="mb-3 mb3-class-country select-container">

                                <MySelect placeholder={'País'}
                                    values={data?.[0]?.data}
                                    setValue={setValue}
                                    name={'alternativePhonePrefixId'}
                                    {...register('alternativePhonePrefixId', { required: false })}
                                    isRequired={false}
                                />
                            </div>

                        </div>



                        <div className="form-floating input-group-phone ">


                            <input type="text"
                                inputMode='tel' className="form-control form-control-height" id="autoSizingInputGroup2"
                                placeholder="Celular alternativo"
                                name={'alternativePhoneNumber'}
                                {...register('alternativePhoneNumber', { required: false })}
                                onChange={(e) => {
                                    // Limpia cualquier símbolo no numérico, como guiones o puntos
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '')
                                }}
                            />

                            <label htmlFor="autoSizingInputGroup2">Celular alternativo</label>


                            {/* <!-- <small className="form-text text-muted small-className">Ingrese 10 dígitos sin el 0 y sin el
                                    15</small> --> */}
                        </div>
                    </div>




                </div>



                <div className="container mt-5 container-mt-5">

                    <span className="address-title">Profesiones</span>

                    <div className="text-start">
                        <div className="mb-3 mb3-class-profession select-container ">
                            <div className="div-profesion">Seleccione una profesión *</div>

                            <GenericSelect placeholder={'Seleccionar'}
                                values={formatDataforGenericSelect(data?.[2]?.data || [])}
                                name={'professionId'}
                                setValue={setValue}
                                {...register('professionId', { required: true })} />
                        </div>

                        <small className="form-text text-muted">Debes ser profesional de la salud y/o del movimiento, como pilates, yoga, educación física, para realizar la formación TPA®</small>
                    </div>

                    {/* 
                    <div className="mb-3 mb3-class-profession select-container ">

                        <div className="div-OProfesion">Otra Profesión</div>

                        <GenericSelect placeholder={'Seleccione otra profesión'} values={data?.[2]?.data || []} name={'otraProfesion'} setValue={setValue} />

                    </div> */}


                </div>


                {selectedValue && selectedValue.value === "si"
                    ?
                    null
                    :
                    <div className="container-mt-5 mt-5-place ">

                        <span className="address-title">Fase Presencial</span>

                        <div className="text-start">
                            <div className="mb-3 mb3-class-where select-container ">

                                <div className="div-place">Donde te gustaría realizar la Fase presencial de la Formación
                                    TPA®? *</div>

                                <GenericSelect
                                    placeholder={'Seleccionar'}
                                    multi={true}
                                    values={formatDataforGenericSelect(data?.[3]?.data || [])}
                                    name={'formationPlacesId'}
                                    closeMenu={false}
                                    {...register('formationPlacesId', { required: true })}
                                    setValue={setValue}
                                />
                            </div>

                            <a className="link-info" href="https://drive.google.com/drive/folders/1EVzvGy5po1qBa7AHPUCFfZaMV9VVAGZu?usp=drive_link" target='blank'>Información sobre la Fase Presencial</a>
                        </div>


                    </div>}




                <div className="submit-button">
                    <input type="submit" className="button-send" value="Enviar" />
                    <small className="form-text text-muted small-cancelar"><a href="/">Cancelar</a></small>

                </div>
                {/* 
                <GenericComponent/> */}


            </form>
        </div>
    )
}